// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"BreadCrumbs_breadCrumbs__8sM8M","crumb":"BreadCrumbs_crumb__GLcgO"};